import { cn } from "@/libs/utils";

import CommonImg from "@/components/Common/Img";

import Check from "@/assets/images/checkbox-check.png";
import CheckboxSmallTrue from "@/assets/images/checkbox-small-true.png";
import CheckboxSmallFalse from "@/assets/images/checkbox-small-false.png";

type Props = {
  size?: "sm" | "md";
  label: string;
  defaultValue?: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
};
export default function CommonCheckbox({
  size = "md",
  label,
  defaultValue = false,
  onChange,
  disabled = false,
}: Props) {
  return (
    <label className="flex gap-[4px] items-center cursor-pointer">
      <input
        type="checkbox"
        className="hidden"
        checked={defaultValue}
        onChange={(e) => {
          const value = e.target.checked;
          onChange?.(value);
        }}
        disabled={disabled}
      />
      {defaultValue ? (
        size === "sm" ? (
          <CommonImg
            className="size-3"
            src={CheckboxSmallTrue}
            alt="Checkbox true"
          />
        ) : (
          <div className="size-4 relative bg-dark-red rounded border border-dark-red">
            <CommonImg
              className="w-3 h-2 left-[1px] top-[3px] absolute"
              src={Check}
              alt="Check"
            />
          </div>
        )
      ) : size === "sm" ? (
        <CommonImg
          className="size-3"
          src={CheckboxSmallFalse}
          alt="Checkbox false"
        />
      ) : (
        <div className="w-4 h-4 bg-white rounded border border-neutral-200" />
      )}
      <div
        className={cn("text-sm font-normal text-gray-B", {
          "text-[10px] font-semibold": size === "sm",
        })}
      >
        {label}
      </div>
    </label>
  );
}
